// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Fragment } from 'react';
import moment from 'moment';
import { Table } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../../infrastructure/utils/common';
import PartyPollsTableMobile from './PartyPollsTableMobile';

const StyledClickableCell = styled.td`
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const PartyPollsTable = ({ polls, history }) => {
  const onCreatorIdClick = creatorId => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    history.push(`/users/${creatorId}`);
  };

  const getFormattedCreatedDate = item => {
    const { createdAt } = item;
    if (!createdAt) return '';
    return moment(createdAt).format('MM/DD/YYYY hh:mm A');
  };

  return (
    <Fragment>
      <h4 className='subheader'>Polling list</h4>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {polls.length > 0 ? (
        <>
          {isMobileResolution() ? (
            <PartyPollsTableMobile
              polls={polls}
              getFormattedCreatedDate={getFormattedCreatedDate}
              onCreatorIdClick={onCreatorIdClick}
            />
          ) : (
            <Table>
              <thead>
                <tr>
                  <th>Poll Question</th>
                  <th>Poll Created By</th>
                  <th>Date Created</th>
                  <th>Answer Options</th>
                  <th>Anonymous</th>
                  <th>Multi-Select</th>
                  <th>Activity Poll</th>
                </tr>
              </thead>
              <tbody>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {polls.map(item => (
                  <tr key={item.pollId}>
                    <td>{item.name}</td>
                    <StyledClickableCell
                      onClick={() => onCreatorIdClick(item.creatorId)}
                    >
                      {item.creatorId}
                    </StyledClickableCell>
                    <td>{getFormattedCreatedDate(item)}</td>
                    <td>
                      {item.answers.map(answer => answer.answerText).join(', ')}
                    </td>
                    <td>{(!!item.anonymous).toString()}</td>
                    <td>
                      {item.metadata
                        ? (!!item.metadata.multiSelect).toString()
                        : 'false'}
                    </td>
                    <td>
                      {item.metadata && item.metadata.activityInfo
                        ? (!!item.metadata.activityInfo.activity).toString()
                        : 'false'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </>
      ) : (
        'None'
      )}
    </Fragment>
  );
};

export default React.memo(PartyPollsTable);
